<template>
<body>
    <div v-bind:class="{ burgerMenuContainer: true, active: showNav }">
    <div @click="mixNav()" class="burgerHeader">
      <a href="/#/" class="closeMenu"><i class="far fa-times"></i></a>
    </div>
    <div class="burgerBody">
      <nav>
        <ul class="topMenu">
          <li>
            <a href="/#/index" target="_self">
              Home
            </a>
          </li>
          <li>
            <router-link to="/shop" target="_self">
              Shop
            </router-link>
          </li>
          <li class="active">
            <router-link to="/user/account" target="_self">
              Account
            </router-link>
          </li>
          <li class="">
              <router-link to="/how-it-works" target="_self">
                How It Works
              </router-link>
            </li>
        </ul>
      </nav>
    </div>
    <div class="burgerBot">
      <p>supremeaccess | Legal | Disclousure</p>
    </div>
  </div>
  <div class="flexLayoutShop">
    <div class="leftSidebar">
      <div class="logoContainer">
        <router-link to="/index"><img src="../../../assets/images/logo-white.svg" alt="" /></router-link>
      </div>
      <section class="sidebarBot">
        <div class="sideBotBod">
          <div class="sideBotFlexMenu">
            <li>
              <router-link to="/index">Home</router-link>
            </li>
            <li>
              <router-link to="/shop">Shop</router-link>
            </li>
            <li class="active">
              <router-link to="/user/account">Account</router-link>
            </li>
          </div>
          <div class="sidePageTitle">
            <h1>Account</h1>
          </div>
        </div>
      </section>
    </div>
    <div class="flexLayoutBody">
      <!-- <span class="pageTitleOnMobile">Account</span> -->
      <div class="cartSidebar">
        <a href="#" class="closeSidebar"><i class="far fa-times"></i></a>
        <h2>Cart</h2>
        <h2>Select Profile</h2>
        <h2>Order Review</h2>
        <h2>Order Review</h2>
        <div class="itemsInCartGrid">
          <div class="indivItemInCart">
            <div class="itemImg">
              <img src="../../../assets/images/lvs.png" alt="" />
            </div>
            <div class="itemInfo">
              <h4>Supreme Backpack</h4>
              <p>Size L</p>
              <a href="#"><i class="far fa-trash"></i></a>
            </div>
          </div>
          <div class="differentProfilesContainer">
            <div class="individProfile mainProfile">
              <h6>John Doe (Main Account)</h6>
              <div class="individInfoP">
                <p>123 Fake Street</p>
                <p>New York, NY 00000</p>
              </div>
            </div>
            <hr />
            <div class="individProfile">
              <h6>John Doe (Main Account)</h6>
              <div class="individInfoP">
                <p>123 Fake Street</p>
                <p>New York, NY 00000</p>
              </div>
            </div>
          </div>
          <div class="orderReviewContainer">
            <div class="individualInput">
              <h4>Coupon</h4>
              <input type="text" name="" id="" value="freesupreme" />
              <span class="percentOff">
                -$150
              </span>
            </div>
            <div class="individualInput">
              <h4>Items (3)</h4>
              <div class="gridListOfInput">
                <div class="individGridList">
                  <h5>Supreme Backpack</h5>
                  <h5>Size L</h5>
                  <h6>$100</h6>
                </div>
                <div class="individGridList">
                  <h5>Supreme Backpack</h5>
                  <h5>Size L</h5>
                  <h6>$100</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="fixedBottomSidebar">
            <div class="totalsContainer">
              <h5>Total:</h5>
              <h5>$150</h5>
            </div>
            <a href="#">Checkout</a>
          </div>
        </div>
      </div>
      <div class="mobileNavTop">
        <a @click="mixNav" href="#" class="iconBarsMobile"><i class="fas fa-bars"></i></a>
        <div class="logoContainerMobile">
          <a href="#"><img src="../../../assets/images/logo-white.svg" alt="" /></a>
        </div>
        <a href="#" class="iconCartMobile openSidebar"><img src="../../../assets/images/icon-cart.svg" alt="" /></a>
      </div>
      <div class="flexLayoutTop">
        <div class="flexLayoutShopFilter">
          <nav class="flexLayoutShopFilterActual">
            <li><router-link to="/user/account">Account Info</router-link></li>
            <li class="">
              <router-link to="/user/profiles">Profiles</router-link>
            </li>
            <li class="active">
              <router-link to="/user/orders">Orders</router-link>
            </li>
            <li>
              <router-link to="/logout">Sign Out</router-link>
            </li>
          </nav>
        </div>
        <div class="flexLayoutTopRight">
          <a href="#" class="openSidebar"><img src="../../../assets/images/icon-cart.svg" alt="" /></a>
        </div>
      </div>
      <div class="flexLayoutActualBody">
        <!-- <h1>My Orders</h1> -->
        <!-- <b-container> -->
          <!-- <h1 class="heading-26">My Orders</h1> -->
          <!-- <div class="text-block-33">Orders</div> -->
          <!-- <div class="container-9 w-container"><a href="#" class="test-order w-button">Test Order</a><a href="#" class="test-order check-out w-button">Test Check Out</a><a href="#" class="export-visiible w-button">Export Visible</a></div> -->
          <!-- <div class="div-block-28"></div> -->
          <b-table hover :items="modOrders" :fields="fields" style="font-family: Roboto, sans-serif; color: #fff;">
          </b-table>
        <!-- </b-container> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
</template>
<script>
import {
  userService
} from '@/services/user'
export default {
  data() {
    return {
        showNav: false,
      fields: [
        'orderId',
        'productTitle',
        'size',
        'style',
        'price',
        'status',
      ],
      orders: [],
      // userInfo: {},
      testOrders: [{
        'orderId': '123',
        'productTitle': 'box logo',
        'status': 'pending',
        'size': '7',
        'price': '55'
      }]
    }
  },
  created() {
    this.$store.dispatch('auth/fetchUser')
    this.$store.dispatch('profiles/getProfiles')
    userService.getOrders()
      .then((resp) => {
        this.orders = resp
      })
      .catch(console.error)
  },
  computed: {
    userInfo() {
      let { user } = this.$store.state.auth
      if (!user) return null
      return user.info
    },
    modOrders() {
	function   sortOrders(a,b) {

	    let a1 = new Date(a.orderDate)

	    let b1 = new Date(b.orderDate)

	    // console.log(a1,b1)

	return b1- a1

	  }

 
	    let {capitalize} = this
      let upperSize = this.orders.map(function(o) {
        o.size = o.size.toUpperCase()
	      if(o.status == 'fail') {
		      o.status = 'refunded'
	      }
	o.status = capitalize(o.status)
        return o
      })
      for (let i=0; i < upperSize.length;i++) {
        if(upperSize[i].style == 'os') {
          upperSize[i].style = 'OS'
        }
      }
      return upperSize.sort(sortOrders)
    },
    profiles() {
      // let {profiles} = this.$store.state.profiles
      // return [profiles[0],profiles[0]]
      return this.$store.state.profiles.profiles
    }
  },
  methods: {
capitalize(s) {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
},
    last4Card(profile) {
      let { card } = profile
      let { number } = card
      return number.slice(-4)
    },
    makeName(profile) {
      let { shipping } = profile
      if (!shipping) return null
      let { firstName, lastName } = shipping
      let fullName = firstName
      if (lastName) fullName = firstName + ' ' + lastName
      return fullName
    },
    addProfile() {
      console.log(`addProfile called`)
    },
    editProfile(profile) {
      console.log(`editing profile ${profile.profileId}`)
    },
    mixNav() {
        this.showNav = !this.showNav;
    }
  }

}
</script>
